import React from "react";
import { PQ, PQ_IMG } from "@/content/pesquisa";
import { Container, Eyebrow, ArrowLink, Reveal } from "@/components/site/ui";

const Nivel = ({ d, testId }) => (
    <div data-testid={testId} className="py-6 border-t border-[#1B3025]">
        <p className="font-sans text-[10.5px] uppercase tracking-[0.26em] text-[#C7A659]">{d.label}</p>
        <p className="mt-3 font-serif font-light text-[17px] md:text-[19px] leading-[1.55] text-[#F2EFE5]">{d.text}</p>
        <p className="mt-3 font-sans font-light italic text-[12.5px] leading-[1.6] text-[#7E8978]">{d.nota}</p>
    </div>
);

// Bloco "Pesquisa" na Home: questão, tese e hipótese do núcleo doutoral.
const Investigacao = () => (
    <section data-testid="home-investigacao" data-section-id="investigacao" className="relative bg-[#0A1812] overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="relative lg:col-span-5 min-h-[38svh] lg:min-h-full">
                <img src={PQ_IMG.contexto} alt="Vista aérea noturna de cidade ribeirinha entre floresta, porto e vias iluminadas" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0A1812] hidden lg:block" />
            </div>
            <Container className="lg:col-span-7 py-20 md:py-28 lg:pl-16 lg:pr-16 max-w-none mx-0">
                <Reveal>
                    <Eyebrow>{PQ.nucleo.eyebrow}</Eyebrow>
                    <p className="font-sans text-[10.5px] uppercase tracking-[0.26em] text-[#7E8978]">{PQ.nucleo.questaoLabel}</p>
                    <h2 data-testid="questao-pesquisa" className="mt-4 font-serif font-light text-[24px] sm:text-[30px] lg:text-[34px] leading-[1.3] text-[#F2EFE5] text-balance">{PQ.nucleo.questao}</h2>
                    <div className="mt-10">
                        <Nivel d={PQ.tese} testId="home-proposicao" />
                        <Nivel d={PQ.hipotese} testId="home-hipotese" />
                    </div>
                    <div className="mt-8">
                        <ArrowLink to="/pesquisa" testId="home-pesquisa-link">Pesquisa</ArrowLink>
                    </div>
                </Reveal>
            </Container>
        </div>
    </section>
);

export default Investigacao;
